import React, { createContext, useContext, useState } from "react";

//  **************
//  ** Contexts **
//  **************
const GlobalThemeContext = createContext();

const useGlobalTheme = () => useContext(GlobalThemeContext);

//  ***************
//  ** Providers **
//  ***************
const GlobalThemeProvider = ({ children }) => {
  //  ***************
  //  ** Variables **
  //  ***************
  const [theme, setTheme] = useState(
    localStorage.getItem("theme") !== null
      ? localStorage.getItem("theme")
      : "light"
  );



  //  ************
  //  ** Return **
  //  ************
  return (
    <GlobalThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </GlobalThemeContext.Provider>
  );
};

export { useGlobalTheme, GlobalThemeProvider };
